import {gql} from "apollo-boost";


export const InscriptionMutation = gql`
    mutation Inscription($dataInscription: DataInscription!) {
        saveInscription(
            dataInscription: $dataInscription
        ){
            statusCode
            message
            redirectUrl
        }
    }

`;

export const InscriptionFunColMutation = gql`
    mutation InscriptionFunCol($dataInscription: DataInscriptionFunCol!){
        saveInscriptionFunCol(dataInscription:$dataInscription){
            statusCode
            message
            redirectUrl
        }
    }
`

export const InscriptionBacMutation = gql`
    mutation InscriptionBac($dataInscription: DataInscriptionBAC!){
        saveInscriptionBac(dataInscription:$dataInscription){
            statusCode
            message
            redirectUrl
        }
    }
`
export const InscriptionBacNoAffiliateMutation = gql`
    mutation InscriptionBac($dataInscription: DataInscriptionBACNoAffi!){
        saveInscriptionBacNoAffiliate(dataInscription:$dataInscription){
            statusCode
            message
            redirectUrl
        }
    }
`
